import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["element"]

  clear() {
    setTimeout(() => {
      this.elementTargets.forEach((element) => {
        element.selectize.clear();
      });
    }, 0);
  }
}